class VimeoPlayer {
	constructor() {
		this.videos = document.querySelectorAll(".vimeo-player");

		if (!this.videos.length) {
			return;
		}

		this.initHlsVimeoPlayers();
	}

	initHlsVimeoPlayers() {
		this.videos.forEach((video) => {
			const videoUrl = video.dataset.videoId;
			if (Hls.isSupported()) {
				var hls = new Hls({
					debug: true,
					enableWorker: false,
					lowLatencyMode: true,
					backBufferLength: 90
				});
				hls.loadSource(videoUrl);
				hls.attachMedia(video);
				hls.on(Hls.Events.MEDIA_ATTACHED, function () {
					video.muted = true;
					video.play();
				});
			}
			// hls.js is not supported on platforms that do not have Media Source Extensions (MSE) enabled.
			// When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video element through the `src` property.
			// This is using the built-in support of the plain video element, without using hls.js.
			else if (video.canPlayType('application/vnd.apple.mpegurl')) {
				video.src = videoUrl;
				video.addEventListener('canplay', function () {
					video.play();
				});
			}
		});
	}

}
